import { Cloudinary } from '@cloudinary/url-gen';
import { jwtDecode } from 'jwt-decode';
import type { UserDetails } from '../models/UserDetails';

export const ROOT_URL: string = 'https://api.alpacatracker.com';

// export const ROOT_URL: string = 'http://localhost:5081';

// if (process.env.NODE_ENV === 'production') {
//   ROOT_URL = '';
// } else {
//   ROOT_URL = 'http://localhost:5000';
//   // ROOT_URL = "https://alpacatracker.com";
//   // ROOT_URL = "https://alpacatracker.azurewebsites.net";
//   // ROOT_URL = "http://localhost:58270";
// }

export const decodeToken = (token?: string) => {
  if (token) {
    const decodedToken = jwtDecode<{
      sub: string;
      'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name': string;
      'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier': string;
      'http://schemas.microsoft.com/ws/2008/06/identity/claims/role': string;
      exp: number;
    }>(token);

    const userDetails: UserDetails = {
      email: decodedToken['sub'] ?? '',
      userName:
        decodedToken[
          'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'
        ],
      userId:
        decodedToken[
          'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier'
        ],
      userRole:
        decodedToken[
          'http://schemas.microsoft.com/ws/2008/06/identity/claims/role'
        ],
      exp: decodedToken.exp,
      // token: token,
    };
    return userDetails;
  }
  return null;
};

export const myCld = new Cloudinary({
  cloud: { cloudName: import.meta.env.VITE_CLOUD_NAME },
  url: {
    secure: true,
  },
});
